<template>
  <div class='institutional-qnr-intro-view is-flex-center gap-2 view p-6' :style="{height: '80vh'}">
      <div class='page-width mr-6 '>
        <div class="pl-2">
        <div class='is-flex-col gap-1 is-size-5'>
          <p class='is-size-4 is-extra-bold'>{{ questionnaireTitle }}</p>
          <p>{{ questionnaireDescription }}</p>
          <div>
            <p>{{ questionnaireDetailedDescription }}</p>
            <br>
            <p>There are no right or wrong answers - people answer across the spectrum.</p>
          </div>
        </div>
        </div>
      </div>
      <div >
        <BehavioralQnrIntroGetStarted :context="context" :startQtrCallbackFn="startQtrCallbackFn"/>
      </div>
  </div>
</template>


<script>
import BehavioralQnrIntroGetStarted from '../../components/institutional_questionnaire/BehavioralQnrIntroGetStarted.vue';

export default {
  name: 'public-behavioral-intro-view',
  components: { BehavioralQnrIntroGetStarted },
  props: {
    context: {
      type: Object,
      required: true
    },
    startQtrCallbackFn: {
      type: Function,
      default: null,
      required: false
    }
  },
  data() {
    return { 
      questionnaireTitle: '',
      questionnaireDescription: '',
      questionnaireDetailedDescription: '',
    };
  },
  beforeCreate() {},
  async created() {
    const urlParams = new URLSearchParams(window.location.search);
    const questionnaireType = urlParams.get('questionnaire_type');
    if (questionnaireType === 'risk') {
      this.questionnaireTitle = 'Risk Tolerance Questionnaire';

      this.questionnaireDescription = `This questionnaire will allow ${this.context.advisor_name || 'us'} to help you understand how your portfolio might align with your risk tolerance.`;
    } else {
      this.questionnaireTitle = 'Behavioral Values Questionnaire';
      this.questionnaireDescription = `This questionnaire will allow ${this.context.advisor_name || 'us'} to help you understand how your portfolio might align with your values.`;
      this.questionnaireDetailedDescription = `The questionnaire draws from academic literature to present questions intended to reveal what is important to you. The questionnaire is not meant to be a definitive declaration of your beliefs, but rather a starting point for you to discuss your values with your financial advisor.`;
    }
  },
  mounted() {},
  updated() {},
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  methods: {},
};
</script>


<style scoped>
.logo {
  border: 1px dashed black;
}
img {
  max-height: 200px;
}
</style>
